export const ColorPalette = {
  primaryBlue: {
    50: "#f0f6fe",
    100: "#ddeafc",
    200: "#c3dafa",
    300: "#99c4f7",
    400: "#69a4f1",
    500: "#4583ec",
    600: "#2a60df",
    700: "#2751ce",
    800: "#2642a7",
    900: "#243c84",
    950: "#1a2651",
  },

  gray: {
    50: "#f7f7f7",
    100: "#ededed",
    200: "#dfdfdf",
    300: "#c8c8c8",
    400: "#adadad",
    500: "#9e9e9e",
    600: "#888888",
    700: "#7b7b7b",
    800: "#676767",
    900: "#545454",
    950: "#363636",
  },

  red: {
    100: "#FEEBEB",
    200: "#FFA39E",
    300: "#F20519",
  },
  yellow: {
    100: "#FFFAD2",
    200: "#FDDD48",
    300: "#F9C700",
  },
  green: {
    100: "#F6FFED",
    200: "#B7EB8F",
    300: "#52C41A",
  },
};
